import { useCallback } from "react";
import { Select, message } from "antd";
import { useRequest } from "ahooks";
import {
  setting as settingService,
  message as messageService,
} from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

function DeductPointSelect({ messageId, defaultValue, callback }) {
  const auth = useAuthContext();
  const { data = { results: [] }, loading } = useRequest(
    () => settingService.listDeductPoint({}, auth.token),
    {
      ready: !!auth.token,
      refreshDeps: [auth.token],
    }
  );

  const changeHandler = useCallback(
    (value) => {
      messageService
        .partialUpdateMessage(
          messageId,
          { deduct_point: value === undefined ? null : value },
          auth.token
        )
        .then(() => {
          message.success("操作成功");
          callback(Date.now());
        })
        .catch((err) => {
          message.error(err.message || err);
        });
    },
    [messageId, callback, auth]
  );

  const optionItems = data.results.map((item) => (
    <Select.Option key={item.id} value={item.id}>
      {item.name}
    </Select.Option>
  ));

  return (
    <Select
      loading={loading}
      defaultValue={defaultValue}
      onChange={changeHandler}
      style={{ width: "80px" }}
      placeholder="空"
      allowClear={true}
    >
      {optionItems}
    </Select>
  );
}

export default DeductPointSelect;
